import { render, staticRenderFns } from "./ILight.vue?vue&type=template&id=0aca027e&scoped=true&"
import script from "./ILight.vue?vue&type=script&lang=js&"
export * from "./ILight.vue?vue&type=script&lang=js&"
import style0 from "./ILight.vue?vue&type=style&index=0&id=0aca027e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca027e",
  null
  
)

export default component.exports